import { createContext, type PropsWithChildren, useContext, useMemo } from 'react';

type ContextValue = {
  markdown?: string;
};

const MarkdownContext = createContext<ContextValue>({});

// Making this context so that markdown can be accessed from the MarkdownComponents renderers, as by default complete markdown is not available to the renderers
export function MarkdownContextProvider({ children, markdown }: PropsWithChildren<ContextValue>) {
  const value = useMemo(() => ({ markdown }), [markdown]);

  return <MarkdownContext.Provider value={value}>{children}</MarkdownContext.Provider>;
}

export const useMarkdownContext = () => useContext(MarkdownContext);
